import {
  AnimatedPage,
  Banner,
  BannerSubtitle,
  BannerTitle,
  lgBumps,
  MainSection,
  NotificationContainer,
  SideSection,
  StickySidebar,
  WideContainer,
  xlBumps,
  xxsBumps,
} from '@wrisk/ui-components'
import React from 'react'

import { getCurrentQuote, getPolicyholder } from '../../../../domain'
import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import {
  HowItWorksSection,
  ProductFaqSection,
  ProposalDocumentsSection,
} from '../../../organisms/product'
import { ProposalPromotionBanner } from '../../../organisms/promotion'
import {
  ProposalConfigurationSection,
  ProposalCoverSection,
  ProposalDetailsView,
  ProposalExcessSection,
} from '../../../organisms/proposal'
import { Footer } from '../../../templates'
import {
  ProposalConfirmationBanner,
  useProposalConfirmation,
} from '../proposalConfirmation'
import { useProposal } from '../ProposalProvider'
import { ProposalContinueButton } from './ProposalContinueButton'
import { ProposalSidebar } from './ProposalSidebar'

const tKey = TKey('pages.proposal-configuration')

export const ProposalConfigurationPage = () => {
  const { t } = useWriskTranslation()

  const { proposal } = useProposal()
  const { isNotConfirmed } = useProposalConfirmation()

  const quote = getCurrentQuote(proposal)
  const profile = getPolicyholder(quote)

  return (
    <AnimatedPage
      pageId='proposal-configuration-page'
      footer={<Footer />}
      data-policynumber={proposal.policyNumber}
    >
      <Banner variant='alternative'>
        <WideContainer flexDirection='column'>
          <BannerSubtitle mb={xxsBumps}>{t(tKey('subheader'))}</BannerSubtitle>
          <BannerTitle>{t(tKey('header'), { profile })}</BannerTitle>
        </WideContainer>
      </Banner>

      <WideContainer>
        <NotificationContainer mb={xlBumps}>
          <ProposalConfirmationBanner />
          <ProposalPromotionBanner />
        </NotificationContainer>
      </WideContainer>

      <WideContainer variant='sidebar'>
        <StickySidebar>
          <SideSection>
            <ProposalSidebar key='desktop' disabled={isNotConfirmed} />
          </SideSection>
        </StickySidebar>
        <MainSection>
          <ProposalSidebar
            key='mobile'
            displayOn='mobile'
            mb={lgBumps}
            disabled={isNotConfirmed}
          />
          <ProposalDetailsView mb={xlBumps} />
          <HowItWorksSection mb={xlBumps} />
          <ProposalConfigurationSection mb={xlBumps} />
          <ProposalCoverSection mb={xlBumps} />
          <ProposalExcessSection mb={xlBumps} />
          <ProductFaqSection mb={xlBumps} />
          <ProposalDocumentsSection quote={quote} mb={xlBumps} />
          <ProposalContinueButton tKey={tKey} layout='fixed' disabled={isNotConfirmed} />
        </MainSection>
      </WideContainer>

      <WideContainer mt={xlBumps}>
        <NotificationContainer mb={xlBumps}>
          <ProposalConfirmationBanner />
        </NotificationContainer>
      </WideContainer>
    </AnimatedPage>
  )
}
